import { flex, IconFont, pointer } from '@byecode/ui'
import styled from 'styled-components'

export const Header = styled.div<{ disableEvent?: boolean }>`
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    color: transparent;
`

export const LeftGroup = styled.div`
    ${flex};
    flex: 1;
    align-items: center;
    overflow: hidden;
    & > *:not(:first-child) {
        margin-left: 12px;
    }
`

export const RightGroup = styled.div`
    ${flex}
    align-items: center;
    & > * {
        margin-left: 12px;
    }
`

export const LinkGroup = styled.div`
    display: flex;
    gap: 12px;
`

export const Icon = styled(IconFont)<{ color?: string; size?: number | string }>`
    font-size: ${({ size }) => (typeof size === 'number' ? `${size || 16}px` : size)};
    ${pointer}
    color: ${({ color }) => color};
`

export const BtnGroup = styled.div`
    ${flex}
    align-items: center;
    gap: 12px;
`

export const UserCenter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    gap: 4px;
`

export const Background = styled.div`
    width: 100%;

    /* 背景模糊，背景叠加 */
    &.backgroundBlur {
        backdrop-filter: blur(12px);
    }
`
